import clsx from "clsx";
import get from "lodash/get";
import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useHistory } from "react-router-dom";

import InfoIcon from "~/components/Icons/icon-settings";
import VideoCamera from "~/components/Icons/VideoCamera";
import PanelWrapper from "~/components/PanelWrapper";
import Button from "~/shared/ui/Fields/Button";
import useVersionContextSpecificSet from "~/versionControl/hooks/useVersionContextSpecificSet";
import { DealerIProps } from "~/entity/Dealer/model/schema";
import { useIvideon } from "~/entity/Ivideon";
import { usePermissions } from "~/shared/context/PermissionContext";

import s from "./BlockAboutDealer.less";

interface BlockAboutDealerProps {
  data: DealerIProps;
  loading: boolean;
}

const BlockAboutDealer = ({ data, loading }: BlockAboutDealerProps) => {
  const { hasPermission, loading: loadingPermissions } = usePermissions();

  // VERSION_CONTROL_CAMERA_CFG
  const blockCameraButton = get(
    useVersionContextSpecificSet(),
    "page.main.hideCameraButton",
    false,
  );
  // VERSION_CONTROL_IVIDEON_CAMERA_CFG
  const blockIvideonCameraButton = get(
    useVersionContextSpecificSet(),
    "page.main.hideIvideonCameraButton",
    false,
  );

  // VERSION_CONTROL_PHOTO_GALLERY_CFG
  const hidePhotoGalleryButton = get(
    useVersionContextSpecificSet(),
    "page.main.hidePhotoGalleryButton",
    false,
  );

  const { t } = useTranslation();
  const history = useHistory();
  const language = localStorage.getItem("language");
  const isEn = language === "en";
  const { sendAction } = useIvideon();

  const {
    id,
    FO,
    FOEn,
    dealerName,
    type,
    country,
    countryEn,
    city,
    cityEn,
    address,
    addressEn,
    PhotoDealerCenter,
  } = data;

  const openPage = (route: string) => () => {
    history.push(route);
  };

  const sendLogAction = async () => {
    await sendAction({
      action: "view_dealers_list",
      description: "Переход по кнопке 'Камеры'",
    });
    openPage("/ivideon/dealers")();
  };

  return (
    <PanelWrapper
      width={582}
      height={120}
      isFixed
      customClassName={s.no_padding}
      loading={loading && !!data}
    >
      <div className={s.about}>
        <NavLink to={`dealers/${id}`}>
          <div className={s.img}>
            {PhotoDealerCenter?.link && (
              <img alt="img" src={PhotoDealerCenter.link} />
            )}
          </div>
        </NavLink>
        <div className={s.content_wrapper}>
          <div className={s.cont}>
            <div className={s.description}>
              <NavLink to={`dealers/${id}`}>
                <div className={s.title}>{dealerName}</div>
              </NavLink>
            </div>
            <div className={s.list_wrap}>
              <ul className={s.list}>
                <li>
                  {t("dealers.type")}
                  <strong>{type}</strong>
                </li>
              </ul>
              <ul className={s.list}>
                <li>
                  {t("dealers.country")}
                  <strong>{isEn ? countryEn : country}</strong>
                </li>
              </ul>
              <ul className={s.list}>
                <li>
                  {t("dealers.FO")}
                  <strong>{isEn ? FOEn : FO}</strong>
                </li>
              </ul>
              <ul className={s.list}>
                <li>
                  {t("dealers.city")}
                  <strong>{isEn ? cityEn : city}</strong>
                </li>
              </ul>
            </div>
            <div className={s.address}>
              <span>{t("dealers.address")} - </span>
              {isEn ? addressEn : address}
            </div>
          </div>
          <div className={s.linkWrapper}>
            <Button
              small
              txtBtn={t("header.changeDealerInfo")}
              customClassName={clsx(s.navButton, s.fillVariant)}
              customIconClassName={s.navButtonIcon}
              onClick={openPage(`dealers/${id}`)}
            >
              <InfoIcon />
            </Button>
            {!blockIvideonCameraButton &&
              hasPermission("ivideon.getDealers") && (
                <Button
                  small
                  txtBtn={t("header.cameraView")}
                  customClassName={s.navButton}
                  customIconClassName={s.ivideonIcon}
                  onClick={sendLogAction}
                >
                  <VideoCamera />
                </Button>
              )}
            {!hidePhotoGalleryButton &&
              hasPermission("dealer.getDealerPhotos") && (
                <Button
                  small
                  txtBtn={t("header.photo_gallery")}
                  customClassName={s.navButton}
                  customIconClassName={s.navButtonIcon}
                  onClick={openPage("/photo-gallery/?page=0&count=25")}
                >
                  <VideoCamera />
                </Button>
              )}
          </div>
        </div>
      </div>
    </PanelWrapper>
  );
};

export default BlockAboutDealer;
